import { PERICARDIAL_FREE_FLUID } from "../groups/cardiac";
import {
  FAST_LEFT_PLEURAL_SPACE,
  FAST_LUQ,
  FAST_PELVIS,
  FAST_RIGHT_PLEURAL_SPACE,
  FAST_RUQ,
} from "../groups/fast";
import { lungSliding } from "../groups/thoracic";
import {
  multi,
  OTHER,
  option,
  text,
  type UsWorksheetDefinition,
} from "../us-fields";

export const US_EFAST: UsWorksheetDefinition = {
  examType: "us_efast",
  version: 1,
  indications: [
    option("blunt_trauma", "Blunt Abdominal/Thoracic trauma"),
    option("penetrating_trauma", "Penetrating Abdominal/Thoracic Trauma"),
    option("hypotension", "Hypotension"),
  ],
  otherIndication: true,
  views: [
    option("ruq", "RUQ"),
    option("luq", "LUQ"),
    option("pelvis", "Pelvis"),
    option("subxiphoid", "Subxiphoid"),
    option("right_lung", "Right lung"),
    option("left_lung", "Left lung"),
  ],
  sections: [
    {
      id: "findings",
      label: "Findings",
      role: "findings",
      technicallyLimited: true,
      fields: [
        FAST_RUQ,
        FAST_LUQ,
        FAST_PELVIS,
        FAST_RIGHT_PLEURAL_SPACE,
        FAST_LEFT_PLEURAL_SPACE,
        PERICARDIAL_FREE_FLUID,
        lungSliding("right", "Right lung"),
        lungSliding("left", "Left Lung"),
        text("efast.other_findings", "Other"),
      ],
    },
    {
      id: "impression",
      label: "Impression",
      role: "impression",
      fields: [
        multi("efast.impression", "Impression", [
          option("negative_efast", "Negative E-FAST"),
          option("abdominal_free_fluid", "Abdominal Free fluid"),
          option("pneumothorax", "Pneumothorax"),
          option("hemothorax", "Hemothorax"),
          option("indeterminate", "indeterminate"),
          OTHER,
        ]),
      ],
    },
  ],
  normalImpressions: [{ sectionId: "impression", value: "negative_efast" }],
  billing: {
    codes: [
      { cpt: "76705", label: "Abdominal ultrasound, limited", preTick: true },
      { cpt: "93308", label: "Echocardiography, limited" },
      { cpt: "76604", label: "Chest ultrasound" },
    ],
  },
};
